/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=4bf481fa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4bf481fa&lang=scss"

import exportComponent from "F:\\System\\sengi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__